module.exports = __webpack_public_path__ + "img/1552539832.ae02fe03.jpg";